import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgUserFollow = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.0422 12.4274C7.15474 13.3818 8.60096 13.9582 10.1818 13.9582C11.5345 13.9582 12.7886 13.5362 13.8196 12.8166C12.5392 15.0653 12.567 18.3861 14.1723 20.2795L14.2327 20.3469L14.2124 20.3251C9.36453 21.139 2 20.355 2 17.9733C2 15.6098 3.62354 13.5442 6.0422 12.4274ZM19.0629 12.4542C19.2946 12.4542 19.4825 12.6421 19.4825 12.8738V14.9717H21.5804C21.8121 14.9717 22 15.1595 22 15.3913V16.7899C22 17.0216 21.8121 17.2094 21.5804 17.2094H19.4825V19.3073C19.4825 19.5391 19.2946 19.7269 19.0629 19.7269H17.6643C17.4326 19.7269 17.2448 19.5391 17.2448 19.3073V17.2094H15.1469C14.9151 17.2094 14.7273 17.0216 14.7273 16.7899V15.3913C14.7273 15.1595 14.9151 14.9717 15.1469 14.9717H17.2448V12.8738C17.2448 12.6421 17.4326 12.4542 17.6643 12.4542H19.0629ZM10.1818 3.36328C12.6922 3.36328 14.7273 5.39835 14.7273 7.90874C14.7273 10.4191 12.6922 12.4542 10.1818 12.4542C7.67143 12.4542 5.63636 10.4191 5.63636 7.90874C5.63636 5.39835 7.67143 3.36328 10.1818 3.36328Z", fill: props.fill }));
});
export default SvgUserFollow;
